import { useState } from "react";
//@ts-ignore
import style from "../../style/Login.module.css";

import {
  ButtonWithoutIcon,
  LinkButton,
  SlideNotification,
  //@ts-ignore
} from "@viuti/recursos";
import EmailPasswordForm from "../../components/loginForm";
import ValidateLoginForm from "./hook/validateLoginForm";
import { IToast } from "../../../../models/interfaces/interfaces";
import validateTheLogin from "./functions/validateTheLogin";
import { LogoAppVertical } from "../../../../models/Icons";
import UnsupportedBrowserBanner from "../../../../components/UnsupportedBrowserBanner/UnsupportedBrowserBanner";

const LoginForm = ({
  loginForm,
  setLoginForm,
  setErrorLoginForm,
  errorLoginForm,
  setCurrentView,
  setBusinessList,
  setLoungesList,
}) => {
  const [canUserContinue, setCanUserContinue] = useState<boolean>(false);
  const [toast, setToast] = useState<IToast>({ message: null, status: null });
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);
  const [isBannerVisible, setIsBannerVisible] = useState(false);

  // When the user types, the form is validated
  ValidateLoginForm(loginForm, setCanUserContinue);

  const onSubmit = (e) => {
    e.preventDefault();
    localStorage.clear();
    validateTheLogin({
      setIsButtonLoading,
      setCanUserContinue,
      setCurrentView,
      loginForm,
      setBusinessList,
      setToast,
      setIsBannerVisible,
      setLoungesList,
    });
  };

  return (
    <>
      <article className={style.mainForm}>
        <span className={style.header}>
          <img className={style.logo} src={LogoAppVertical} alt="Prikly" />
          <h1>
            La plataforma inteligente que digitaliza la gestión de negocios.
          </h1>
        </span>
        <form className={style.form} onSubmit={onSubmit}>
          <EmailPasswordForm
            loginForm={loginForm}
            setLoginForm={setLoginForm}
            error={errorLoginForm}
            setError={setErrorLoginForm}
          />
          <footer className={style.footer}>
            <ButtonWithoutIcon
              width="100%"
              isPrimary={true}
              textBttn="Iniciar sesión"
              isDisabled={!canUserContinue || isButtonLoading}
              handleClick={() => {}}
              isLoading={isButtonLoading}
              buttonProps={{
                type: "submit",
              }}
              id="login_signIn_click_submitForm"
            />
            <div className={style.utilLinks}>
              <LinkButton
                path={"/recuperar"}
                id="login_signIn_click_forgotPassword"
              >
                ¿Olvidaste tu contraseña?
              </LinkButton>
              <LinkButton
                path={"/onboarding/main"}
                id="login_signIn_click_onboardingAdmin"
                target="_blank"
              >
                ¿No tienes cuenta?
              </LinkButton>
            </div>
          </footer>
          {/* <div className={style.divider}>o</div> */}
        </form>
        {toast.message && (
          <SlideNotification
            state={{
              message: toast.message,
              status: toast.status,
            }}
            clearStatus={() =>
              setToast({
                message: null,
                status: null,
              })
            }
          />
        )}
      </article>
      <UnsupportedBrowserBanner
        visibility={{
          isVisible: isBannerVisible,
          setIsVisible: setIsBannerVisible,
        }}
      />
    </>
  );
};

export default LoginForm;
